import type { ComponentPropsWithoutRef } from "react";

type FormProps = Omit<ComponentPropsWithoutRef<"form">, "onSubmit"> & {
  onSubmit: () => void | Promise<void>;
};

export const Form = ({ onSubmit, ...props }: FormProps) => {
  return (
    <form
      {...props}
      onSubmit={(event) => {
        event.preventDefault();
        void onSubmit();
      }}
    />
  );
};
